import {
  Divider,
  Stack,
  DialogContent,
  DialogActions,
  Dialog,
  Button,
  MenuItem,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { LoadingButton } from '@mui/lab';
import { yupResolver } from '@hookform/resolvers/yup';

import { Strings } from '@app/constants';
import { FormProvider, RHFDatePicker, RHFTextField, Scrollbar } from '@app/components';
import { Header } from '@app/sections/header';
import { ISchedule } from '../type';
import { addSchedule } from '../slice';
import { useRequestState } from '@app/hooks';
import { selectAddScheduleState } from '../selecter';
import { addScheduleSchema } from '../validators';

interface Props {
  open: boolean;
  onClose: VoidFunction;
}

const AddSchedule = ({ open, onClose }: Props) => {
  const dispatch = useDispatch();

  const methods = useForm<ISchedule>({
    resolver: yupResolver(addScheduleSchema) as any,
  });
  const Priority = [
    { id: 1, name: 'High' },
    { id: 2, name: 'Medium' },
    { id: 3, name: 'Low' },
  ];
  const onSubmit = (form: ISchedule) => {
    dispatch(addSchedule({ ...form }));
  };
  const { loading } = useRequestState({
    stateSelector: selectAddScheduleState,
    onSuccess: onClose,
    successMessageShown: true,
    errorShown: true,
  });
  return (
    <>
      <FormProvider methods={methods}>
        <Dialog open={open} fullWidth>
          <Header variant="dialog" title={Strings.button.addNewTask} onClose={onClose} />
          <Divider />
          <Scrollbar>
            <DialogContent>
              <Stack spacing={2} my={2}>
                <RHFTextField
                  name="name"
                  required
                  label={Strings.field.name}
                  fullWidth
                  variant="outlined"
                  multiline
                />
                <RHFTextField
                  select
                  name="priority"
                  label={Strings.dashboard.setThePriority}
                  required
                >
                  {Priority.map((type) => (
                    <MenuItem key={type.id} value={type.name}>
                      {type.name}
                    </MenuItem>
                  ))}
                </RHFTextField>
                <RHFDatePicker required label={Strings.field.date} name="date" fullWidth />
                <RHFTextField
                  name="description"
                  label={Strings.field.description}
                  multiline
                  minRows={5}
                />
              </Stack>
            </DialogContent>
          </Scrollbar>
          <Divider />
          <DialogActions>
            <Button variant="outlined" color="inherit" onClick={onClose}>
              {Strings.button.cancel}
            </Button>
            <LoadingButton
              variant="contained"
              type="submit"
              loading={loading}
              onClick={methods.handleSubmit(onSubmit)}
            >
              {Strings.button.save}
            </LoadingButton>
          </DialogActions>
        </Dialog>
      </FormProvider>
    </>
  );
};

export { AddSchedule };
